import { useApolloQuery } from '@/gql/apolloWrapper';
import {
  BillingPaymentMethod,
  PaymentMethodStatus,
  PaymentMethodType,
  ProductKey,
  useGetBillingInfoPaymentMethodsQuery,
} from '@/gql/generated';
import useCurrentCompany from '@/hooks/useCurrentCompany/useCurrentCompany';
import { resolvePlanTier } from '@/hooks/usePlanAccess/planTier';
import { computed, ref, watch } from '@nuxtjs/composition-api';

const { companyId, company } = useCurrentCompany();

const useProductCopy = () => {
  const paymentMethods = ref<BillingPaymentMethod[]>([]);
  const isLoading = ref(false);

  const unwatch = watch(
    companyId,
    (id) => {
      if (id) {
        useApolloQuery(
          useGetBillingInfoPaymentMethodsQuery,
          { input: { companyId: companyId.value } },
          {
            data: paymentMethods,
            pending: isLoading,
          },
          {
            placeholderPick: ({ getBillingInfo: res }) => res.paymentMethods,
            force: true,
          }
        );

        unwatch?.();
      }
    },
    { immediate: true }
  );

  const hasACH = computed(() =>
    paymentMethods.value?.some((m) => {
      return (
        m.type === PaymentMethodType.BankAccount &&
        m.status === PaymentMethodStatus.Active
      );
    })
  );

  const isAboveTierThreshold = computed(
    () => (resolvePlanTier(undefined, company.value.plan) ?? -1) > 3
  );

  const copy = computed(() => ({
    // [ProductKey.ManagedHrServices]: {
    //   title: 'Managed Services',
    //   description:
    //     'Our Bambee HR Managers are on your side, ready to handle the difficult talks and situations on your behalf.',
    //   features: [
    //     'Direct Bambee HR Involvement',
    //     'Guided Compliance Management',
    //     'Cost-Effective Engagement',
    //     'Compliance Assurance',
    //     'Audit Ready Documentation',
    //     'Operational Peace of Mind',
    //   ],
    //   img: '/images/hand-shake-doc.svg',
    // },
    [ProductKey.WebinarWorkplaceViolence]: {
      title: 'Workplace Violence Protection Training Program ',
      shortTitle: 'Workplace Violence Webinar',
      description: `Expert guidance, custom policies, and essential training tools to meet workplace violence prevention requirements.`,
      features: [
        'Workplace Violence Prevention Masterclass',
        'Workplace Prevention Strategy Session',
        'Workplace Violence Prevention Plan',
        'OSHA Incident Log Template',
        'OSHA Hazard Log Template',
        'Training Log Templates',
      ],
      purchaseCta: 'Purchase',
    },
  }));

  return {
    copy,
    hasACH,
    isAboveTierThreshold,
  };
};

export default useProductCopy;
